import { useContext } from 'react';
import { LocaleContext } from './constants.js';

function useLocaleContext() {
  return useContext(LocaleContext);
}

export default useLocaleContext;
